import { InputOTP, InputOTPGroup, InputOTPSlot } from "@/ds/shadcn/components/ui/input-otp";
import { REGEXP_ONLY_DIGITS } from "input-otp";
import type { FC } from "react";

export interface MfaCodeInputProps {
	value: string;
	onChange: (value: string) => void;
	disabled?: boolean;
	ref?: React.Ref<HTMLInputElement>;
	error?: boolean;
}

export const MfaCodeInput: FC<MfaCodeInputProps> = ({ value, onChange, disabled, ref, error }) => {
	return (
		<div className="flex justify-center">
			<InputOTP aria-invalid={error} ref={ref} maxLength={6} pattern={REGEXP_ONLY_DIGITS} value={value} onChange={onChange} disabled={disabled}>
				<InputOTPGroup>
					<InputOTPSlot className="text-xl p-6" index={0} />
					<InputOTPSlot className="text-xl p-6" index={1} />
					<InputOTPSlot className="text-xl p-6" index={2} />
					<InputOTPSlot className="text-xl p-6" index={3} />
					<InputOTPSlot className="text-xl p-6" index={4} />
					<InputOTPSlot className="text-xl p-6" index={5} />
				</InputOTPGroup>
			</InputOTP>
		</div>
	);
};
